import React from "react";
import {
  Route,
  Switch,
  NavLink,
  useLocation,
  useQueryParamString
} from "polyrouter";
import { Layout } from "views/Main/Layouts";
import PolicyInheritance from "./PolicyInheritance";
import PolicyListRouter from "./PolicyList";
import { useTranslation } from "utilities/i18n";
import "./PolicyList.scss";
import PolicyDetails from "./PolicyDetails";

const policyScopeOptions = ["device", "user_group", "site", "group", "model"];

export const PolicyRouter: React.FC = () => {
  const { Sidebar } = Layout;
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const isDetailsView = pathname.includes("/details");
  const [previous] = useQueryParamString("previous");

  const scope =
    previous && policyScopeOptions.includes(previous) ? previous : "model";

  return (
    <div className="policy">
      <Layout
        back={
          isDetailsView
            ? {
                to: `/manage/policy/list/${scope}`,
                persist: ["PolicyFilterState", "previous"],
                iconDesc: t("RETURN_TO_POLICIES"),
                title: t("POLICIES"),
                linkDataId: "back-button"
              }
            : undefined
        }
      >
        {!isDetailsView && (
          <Sidebar>
            <span className="title-capitalized">{t("POLICIES")}</span>
            <ul className="menu router">
              <li>
                <NavLink nest exact to="">
                  {t("OVERVIEW")}
                </NavLink>
              </li>
              <li>
                <NavLink
                  nest
                  exact
                  to="/list/:scope"
                  persist={["PolicyFilterState"]}
                  params={{ scope: "device" }}
                >
                  {t("INDIVIDUAL_DEVICE")}
                </NavLink>
              </li>
              <li>
                <NavLink
                  nest
                  exact
                  to="/list/:scope"
                  persist={["PolicyFilterState"]}
                  params={{ scope: "user_group" }}
                >
                  {t("DEVICE_USER_GROUP")}
                </NavLink>
              </li>
              <li>
                <NavLink
                  nest
                  exact
                  to="/list/:scope"
                  persist={["PolicyFilterState"]}
                  params={{ scope: "site" }}
                >
                  {t("SITE")}
                </NavLink>
              </li>
              <li>
                <NavLink
                  nest
                  exact
                  to="/list/:scope"
                  persist={["PolicyFilterState"]}
                  params={{ scope: "group" }}
                >
                  {t("DEVICE_GROUP")}
                </NavLink>
              </li>
              <li>
                <NavLink
                  nest
                  exact
                  to="/list/:scope"
                  persist={["PolicyFilterState"]}
                  params={{ scope: "model" }}
                >
                  {t("DEVICE_MODEL")}
                </NavLink>
              </li>
            </ul>
          </Sidebar>
        )}
        <Switch>
          <Route nest path="/details">
            <PolicyDetails />
          </Route>
          <Route nest path="/list">
            <PolicyListRouter />
          </Route>
          <Route exact path="">
            <PolicyInheritance />
          </Route>
        </Switch>
      </Layout>
    </div>
  );
};
